import { connect } from 'react-redux';
import { compose, withState, withHandlers, branch, renderNothing } from 'recompose';
import { t } from '../../../../modules/infra/i18n';

import { updateUser } from '../../users/actions';
import { getIsConnectedUser } from '../../users/selectors';
import withNotifications from '../../../common/withNotifications';
import confirmModal from '../../../common/confirmModal';

const enhance = compose(
  branch(
    props => !props.id,
    renderNothing,
  ),
  connect((state, props) => ({
    isConnectedUser: getIsConnectedUser(state, props.id),
  }), { updateUser }),
  branch(
    props => !props.isConnectedUser,
    renderNothing,
  ),
  withNotifications,
  withState('clicked', 'setClicked', false),
  withHandlers({
    logout: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: t('admin:logout_user_sessions.confirm_modal.title'),
        message: t('admin:logout_user_sessions.confirm_modal.message'),
      });

      if (!confirmed) {
        return false;
      }

      return props.updateUser(props.id, { invalidateToken: true }).then(() =>
        props.addNotification({
          title: t('admin:logout_user_sessions.success.title'),
          level: 'success',
          message: t('admin:logout_user_sessions.success.message'),
        })
      );
    },
  }),
);

export default enhance;
